export default __webpack_public_path__ + "static/media/pacfreshnz.11e64d79.png";